import React from 'react'
import {Popconfirm, Button} from "antd";
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";


const IngredientsDelete = ({responseIndex}) => {

    const {byId} = React.useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    const handleDeleteClick = () => {
        let mockRows = Object.assign({}, recipeById)
        mockRows.billOfMaterials.splice(responseIndex, 1)
        setRecipeById(mockRows)
    }

    return(
        <React.Fragment>
            <Popconfirm
                title={'Silmek istediğinize emin misiniz ?'}
                okText={'SİL'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'danger'}}
                onConfirm={handleDeleteClick}
            >
                <Button
                    type={'link'}
                    danger
                >
                    Sil
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default IngredientsDelete